import Icon from '../Icon';
import type { IconNode, LucideProps } from '../types';

const iconNode: IconNode = [
  ['path', { d: 'M10 12h4', key: 'a56b0p' }],
  ['path', { d: 'M10 17h4', key: 'pvmtpo' }],
  ['path', { d: 'M10 7h4', key: '1vgcok' }],
  ['path', { d: 'M18 12h2', key: 'quuxs7' }],
  ['path', { d: 'M18 18h2', key: '4scel' }],
  ['path', { d: 'M18 6h2', key: '1ptzki' }],
  ['path', { d: 'M4 12h2', key: '1ltxp0' }],
  ['path', { d: 'M4 18h2', key: '1xrofg' }],
  ['path', { d: 'M4 6h2', key: '1cx33n' }],
  ['rect', { x: '6', y: '2', width: '12', height: '20', rx: '2', key: '749fme' }],
];

/**
 * @component @name Microchip
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTJoNCIgLz4KICA8cGF0aCBkPSJNMTAgMTdoNCIgLz4KICA8cGF0aCBkPSJNMTAgN2g0IiAvPgogIDxwYXRoIGQ9Ik0xOCAxMmgyIiAvPgogIDxwYXRoIGQ9Ik0xOCAxOGgyIiAvPgogIDxwYXRoIGQ9Ik0xOCA2aDIiIC8+CiAgPHBhdGggZD0iTTQgMTJoMiIgLz4KICA8cGF0aCBkPSJNNCAxOGgyIiAvPgogIDxwYXRoIGQ9Ik00IDZoMiIgLz4KICA8cmVjdCB4PSI2IiB5PSIyIiB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHJ4PSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/microchip
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Microchip = (props: LucideProps) => <Icon {...props} iconNode={iconNode} name="microchip" />;

export default Microchip;
